import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {BaseError} from "../base-error";
import {Store} from "../../../services/store.service";
import {ComponentTabs} from "../../../models/component-tabs";
import {TabRow} from "../../../models/tab-row";
import {ComponentTabControllerService} from "../../../services/form-controller/component-tab-controller.service";
import FormUtils from "../../utils/form-utils.component";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {IPostMessageEventTarget, PostMessageBridgeFactory} from "@tekool/ngx-post-message-angular-9";
import {IPostMessageBridge} from "@tekool/ngx-post-message-angular-9/src/IPostMessageBridge";
import * as _ from "lodash";
import StyleService from "../../../services/style-service/style-service";
import {IIconItem} from "../../../models/sytles/icon-item";

@Component({
  selector: "component-tabs",
  templateUrl: "./tabs.component.html",
  styles: [],
  providers: [],
})
export class TabsComponent extends TranslatedBaseError implements OnInit, OnDestroy {

  @Input() public serviceId: string;
  @Input() public componentKey: string;
  @Input() public componentTabId: string;
  @Input() public determinantMapById: { [key: string]: string } = {};
  @Output() public changed = new EventEmitter();

  public componentTabs: ComponentTabs = new ComponentTabs();
  public newRow: TabRow = new TabRow("", "");
  public selectedRow: TabRow = new TabRow("", "");
  public showDeterminantBuilder: boolean = false;
  public selectedIndex: number;
  public listToggle: boolean = false;
  private messageBridge: IPostMessageBridge;
  private tabComponentData?: any;
  public icons: IIconItem[] = [];
  public dataChanged = false;
  public showDrawerHeader: boolean = true;
  public tempDeterminant: any = null;

  constructor(private componentTabControllerService: ComponentTabControllerService,
              public store: Store,
              @Inject(PostMessageBridgeFactory) private bridgeFactory: PostMessageBridgeFactory,
              toastr: ToastrService, public translateService: TranslateService, private styleService: StyleService) {
    super(toastr, translateService);
    this.messageBridge = bridgeFactory.makeInstance()
      .setEnableLogging(true)
      .connect(window, window.top)
      .makeBridge("FormBuilder")
      .addListener("FormBuilder", (messageString: any) => {
        const data = JSON.parse(messageString);
        if (data.event === "receivedCurrentComponent" && data.serviceId === this.serviceId && data.data && data.data.key === this.componentKey) {
          this.tabComponentData = data.data;
          this.load();
        }
      });
  }

  public ngOnInit(): void {
    window.top.postMessage([{
      channel: "FormBuilder",
      message: JSON.stringify({event: "receiveCurrentComponent"}),
    }], "*");
    this.styleService.getIcons().subscribe((icons) => {
      this.icons = icons;
    });
  }

  public showModalHeader(e) {
    console.log(e);
    this.showDrawerHeader = e;
  }

  public dropped(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.save();
    }
  }

  public fixIndexes() {
    this.componentTabs.tabItems.forEach((it, index) => {
      it.sortOrder = index;
    });
  }

  public addNewRow(): void {
    if (!this.componentTabs) {
      this.componentTabs = new ComponentTabs();
    }
    const copy: TabRow = JSON.parse(JSON.stringify(this.newRow));
    this.componentTabs.tabItems.push(copy);
    this.newRow = new TabRow("", "");
    this.save();
  }

  public isAddButtonDisabled(): boolean {
    return !this.newRow.key || !this.newRow.label;
  }

  public openDeterminantModal(row: TabRow) {
    if (row) {
      this.selectedRow = row;
    } else {
      this.createNewRow();
    }
    this.showDeterminantBuilder = true;

    this.showAsFullDrawer();
  }

  public createNewRow() {
    this.selectedRow = new TabRow("", "");
    this.componentTabs.tabItems.push(this.selectedRow);
  }

  public closeDeterminantLayer() {
    this.tempDeterminant = null;
    this.showDeterminantBuilder = false;
    this.backAsFramedDrawer();
  }

  public closeEdit() {
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
  }

  public setListView(b: boolean) {
    this.listToggle = b;
  }

  public showAsFullDrawer() {
    const windowParent = window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-content > div > div");
    console.log("windowParent", windowParent);
    if (windowParent) {
      windowParent.querySelectorAll("iframe")?.forEach(iframe => iframe.classList.add("full-drawer"));
      windowParent.querySelector(".page-iframe")?.classList.add("full-drawer-content");
      windowParent.querySelector(":scope > .row:nth-child(1)")?.classList.add("d-none");
      windowParent.querySelector(":scope > .row:nth-child(2)")?.classList.add("p-0");
      windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector("#myBuilder").classList.add("m-0");
      windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector(".tab-pane.active").classList.add("p-0", "m-0");
      // windowParent.querySelector(":scope > .row:last-child")?.classList.add("d-none");
      window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-close")?.classList.add("d-none");
      windowParent.querySelector("#element1")?.querySelector(":scope > .formio-component-tabs")?.querySelector(":scope > div > .nav-tabs")?.classList.add("d-none");
    }
  }

  public backAsFramedDrawer() {
    const windowParent = window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-content > div > div");
    if (windowParent) {
      windowParent.querySelectorAll("iframe")?.forEach(iframe => iframe.classList.add("full-drawer"));
      windowParent.querySelector(".page-iframe")?.classList.remove("full-drawer-content");
      windowParent.querySelector(":scope > .row:nth-child(1)")?.classList.remove("d-none");
      windowParent.querySelector(":scope > .row:nth-child(2)")?.classList.remove("p-0");
      windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector("#myBuilder").classList.remove("m-0");
      windowParent.querySelector(":scope > .row:nth-child(2)")?.querySelector(".tab-pane.active")?.classList.remove("p-0", "m-0");
      // windowParent.querySelector(":scope > .row:last-child")?.classList.remove("d-none");
      window.parent.document.querySelector(".component-settings")?.querySelector(".formio-dialog-close")?.classList.remove("d-none");
      windowParent.querySelector("#element1")?.querySelector(":scope > .formio-component-tabs")?.querySelector(":scope > div > .nav-tabs")?.classList.remove("d-none");
    }
  }

  public isDeterminantEmpty(jsonDeterminant: string): boolean {
    if (jsonDeterminant) {
      const dets = JSON.parse(jsonDeterminant)[0].items;
      return !(dets && dets.length > 0);
    }
    return true;
  }

  public determinantCount(jsonDeterminant: string): number {
    let nrOfConditions: number = 0;
    if (jsonDeterminant) {
      const conditions = JSON.parse(jsonDeterminant);
      for (const group of conditions) {
        nrOfConditions += group.items.length;
      }
    }
    return nrOfConditions;
  }

  private load() {
    const cb = (data: ComponentTabs) => {
      const componentTabs = data || new ComponentTabs();
      this.componentTabId = data.id;
      componentTabs.tabItems.sort((a, b) => a.sortOrder - b.sortOrder);

      if (this.tabComponentData && this.tabComponentData.components) {
        const tabItems = [...componentTabs.tabItems];
        const tabRows = [];
        for (const tabComp of this.tabComponentData.components) {
          let tabItem = tabItems.find((item) => item.id && item.id === tabComp.id);
          if (!tabItem) {
            tabItem = tabItems.find((item) => item.key && item.key === tabComp.key);
          }
          if (tabItem) {
            tabItem.key = tabComp.key;
            const index = tabItems.indexOf(tabItem);
            tabItems.splice(index, 1);
          } else {
            tabItem = new TabRow(tabComp.label, tabComp.key);
            tabItem.group = tabComp.group;
            tabItem.icon = tabComp.icon;
            tabItem.titleMode = tabComp.titleMode;
            tabItem.iconPosition = tabComp.iconPosition;
            tabItem.workingLabel = tabComp.workingLabel;
            tabItem.hasTopSeparator = tabComp.hasTopSeparator;
          }
          tabItem.label = tabComp.label;
          tabRows.push(tabItem);
        }
        if (!_.isEqual(tabRows, componentTabs.tabItems)) {
          this.componentTabs = componentTabs;
          componentTabs.tabItems = tabRows;
          this.save();
        }
      }
      this.componentTabs = componentTabs;
    };

    if (this.componentTabId) {
      this.componentTabControllerService.getById(this.componentTabId).subscribe(cb,
        (error) => this.showErrorMessage(error),
      );
    } else {
      this.componentTabControllerService.get(this.serviceId, this.componentKey).subscribe(cb,
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public updateDeterminant(event: any) {
    if (this.selectedRow) {
      this.selectedRow.jsonDeterminants = this.tempDeterminant.jsonString;
      this.save();
    }
  }

  private static sendSaveProcessingEvent(state = true, deletedTabs = null) {
    window.top.postMessage([{
      channel: "FormBuilder",
      message: JSON.stringify({
        event: "saveProcessing",
        deletedComponentKeys: deletedTabs && deletedTabs.map((tab) => tab.key),
        state,
      })}], "*");
  }

  public disableSave() {
    TabsComponent.sendSaveProcessingEvent();
  }

  public save(deletedTabs = null) {
    TabsComponent.sendSaveProcessingEvent(true, deletedTabs);
    this.fixIndexes();
    const cb = (ct) => {
      this.closeDeterminantLayer();
      this.responseSuccessful("Component updated!");
      ct?.tabItems?.sort((a, b) => a.sortOrder - b.sortOrder);

      Object.assign(this.componentTabs, ct);
      this.componentTabId = ct.id;
      this.changed.emit({
        componentTabId: this.componentTabId,
        tabItems: this.componentTabs.tabItems.map((tab) => {
          return {
            id: tab.id,
            label: tab.label,
            workingLabel: tab.workingLabel,
            hasTopSeparator: tab.hasTopSeparator,
            key: tab.key,
            hidden: tab.hidden,
            group: tab.group,
            titleMode: tab.titleMode,
            iconPosition: tab.iconPosition,
            icon: tab.icon,
            condition: this.determinantCount(tab.jsonDeterminants),
          };
        }),
      });

      TabsComponent.sendSaveProcessingEvent(false);
    };
    const errorCb = (error) => {
      this.showErrorMessage(error);
      TabsComponent.sendSaveProcessingEvent(false);
    };

    if (this.componentTabId) {
      this.componentTabControllerService.saveById(this.componentTabId, this.componentTabs).subscribe(cb, errorCb);
    } else {
      this.componentTabControllerService.save(this.serviceId, this.componentKey, this.componentTabs)
        .subscribe(cb, errorCb);
    }
  }

  public deleteRow(index: number): void {
    if (index > -1) {
      const deletedTabs = this.componentTabs.tabItems.splice(index, 1);
      this.save(deletedTabs);
    }
  }

  public toggleVisibleRow(index: number): void {
    if (index > -1) {
      this.componentTabs.tabItems[index].hidden = !this.componentTabs.tabItems[index].hidden;
      this.save();
    }
  }

  public labelChanged(item: TabRow): void {
    item.key = item.label ? (this.componentKey + FormUtils.generateGuideIdFromTitle(item.label)) : "";
  }

  public onItemGroupChanged(e: any, item: any) {
    this.save();
  }

  public ngOnDestroy(): void {
    this.messageBridge.removeAllListeners("FormBuilder");
  }

  public changeData() {
    this.dataChanged = true;
    console.log("changeData");
  }

  public extraPropsDropdownOpenChanged(state: any) {
    if (!state && this.dataChanged) {
      this.save();
    }
  }
}
